import { injectIntl } from "react-intl";

import {
  List,
  ListItem,
  concatValues,
  withBrowser,
  browserShape,
  intlShape,
} from "lcm-iot-commons";

import {
  networkInterfaceIconClassName,
  statusBubbleNetworkInterface,
} from "../../utils/statusUtils";
import { EdgeDeviceTypes } from "./EdgeDeviceConstants";

type Props = {
  networkInterfaces: {
    id?: number;
    name?: string;
    description?: string;
    type?: string;
    modus?: string;
    number?: number;
    ip_address?: string;
    status?: string;
  }[];
  browser: browserShape;
  intl: intlShape;
  edgeDevice: {
    id?: number;
    lastSeenAt?: number;
    type?: {
      code?: string;
    };
  };
};

export function NetworkInterfaces({
  intl,
  browser,
  edgeDevice,
  networkInterfaces,
}: Props) {
  return (
    <div>
      <h2 id="network-interfaces-header">
        {intl.formatMessage({ id: "network_interfaces.header" })}
      </h2>
      <List id="network-interfaces-list">
        {networkInterfaces.map((networkInterface) => (
          <ListItem
            id={`network-interface-list-item-${networkInterface.id}`}
            key={networkInterface.id}
            title={
              edgeDevice.type?.code === EdgeDeviceTypes.SGC500_AC
                ? networkInterface.name
                : concatValues(
                    [
                      `${networkInterface.type} ${networkInterface.number}`,
                      networkInterface.name,
                    ],
                    " - ",
                  )
            }
            value={
              networkInterface.modus === "DHCP"
                ? `${networkInterface.ip_address} (DHCP)`
                : networkInterface.ip_address
            }
            icon={networkInterfaceIconClassName()}
            status={statusBubbleNetworkInterface(
              networkInterface.status,
              // @ts-expect-error TS(2345) FIXME: Argument of type '{ id?: number | undefined; lastS... Remove this comment to see the full error message
              edgeDevice,
            )}
            description={networkInterface.description}
            onClick={() =>
              browser.navigateTo(
                `/edge_devices/${edgeDevice.id}/network_interfaces/${networkInterface.id}`,
              )
            }
            // @ts-expect-error TS(2322) FIXME: Type '{ id: string; key: number | undefined; title... Remove this comment to see the full error message
            showItemMenu
          />
        ))}
      </List>
    </div>
  );
}

export default injectIntl(withBrowser(NetworkInterfaces));
